const noop = () => {};

class ProgressLoader{

	constructor(fileUrl, options){

		this.onProgress	= this.onProgress.bind(this);
		this.onLoaded	= this.onLoaded.bind(this);
		this.cache = this.getCache('images');

		this.options = Object.assign({
			start: true,
			onStart: noop,
			onProgress: noop,
			onAbort: noop,
			notifiedNotComputable: false,
			responseType: 'arraybuffer'
		}, options);

		this.file = fileUrl;
		this.promise = this.load();

	}

	load() {

		return new Promise((resolve, reject) => {

			if (this.inCache(this.file)) {
				resolve();
			}

			this.xhr = new XMLHttpRequest();
			this.xhr.open('GET', this.file, true);
			this.xhr.responseType = this.options.responseType;
			this.xhr.onprogress = this.onProgress;
			this.xhr.onloadend = this.onLoaded;

			if (this.options.start) {

				this.start();

			}

		});

	}

	onProgress(ev) {

		if (ev.lengthComputable) {

			this.options.onProgress(parseInt((ev.loaded / ev.total) * 100))

		} else {

			if (!this.options.notifiedNotComputable) {
				this.options.notifiedNotComputable = true;
				this.options.onProgress(ev);
			}

		}

	}

	onLoaded(){

		if (!this.xhr.status.toString().match(/^2/)) {

			this.onError(this.xhr);
			Promise.resolve(this.xhr);
			// reject(this.xhr);

		} else {

			this.addToCache('images', this.file);

			var options = {}
			var headers = this.xhr.getAllResponseHeaders();
			var m = headers.match(/^Content-Type\:\s*(.*?)$/mi);
			if (m && m[1]) {
				options.type = m[1];
			}

			// var blob = new Blob([this.response], options);

            try {
                var blob = new Blob([this.response], {
                    type: "text/csv;charset=utf-8"
                });
            } catch (e) {
                if (e.name == "InvalidStateError") {
                    var bb = new MSBlobBuilder();
                    bb.append(this.response);
                    var blob = bb.getBlob('text/csv;charset=utf-8');
                } else {
                    console.log('blob doesn\'t work');
                }
            }

			this.options.onComplete(this.file, window.URL.createObjectURL(blob));
			Promise.resolve(window.URL.createObjectURL(blob));
			// resolve(window.URL.createObjectURL(blob));

		}

	}

	start() {

		this.options.onStart()
		this.xhr.send();

	}

	abort() {

		this.options.onAbort();
		this.xhr.abort();

	}

	getCache(block) {

		return window.sessionStorage.getItem(block) || '';

	}

	inCache(item) {

		return this.cache.indexOf(item) !== -1

	}

	addToCache(block, item) {

		let cached = this.getCache(block);
		if (cached.indexOf(item) === -1) {
			cached += item;
		}
		this.cache = cached;
		window.sessionStorage.setItem(block, cached);

	}

}


export default ProgressLoader;



// WEBPACK FOOTER //
// ./js/plugins/progressLoader.js